import * as React from "react"

import { useChat } from "@/chat/store"
import { voiceSupported } from "@/chat/voice"

/**
 * Joins or leaves a room's voice chat and keeps the microphone error, if
 * any, for whoever renders it. Shared by the header button and the panel so
 * both report the same failure.
 */
export function useVoiceControls(roomId: string) {
  const { call, joinVoice, leaveVoice } = useChat()
  const [error, setError] = React.useState<string | null>(null)
  const inThisRoom = call?.roomId === roomId

  async function toggle() {
    setError(null)
    if (inThisRoom) {
      leaveVoice()
      return
    }
    try {
      await joinVoice(roomId)
    } catch (caught) {
      setError(
        caught instanceof Error ? caught.message : "Не удалось подключиться."
      )
    }
  }

  return { inThisRoom, toggle, error, supported: voiceSupported() }
}

export type VoiceControls = ReturnType<typeof useVoiceControls>
